import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { toneEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import { BookingStatus } from '@/types/BookingStatus.ts';
import { BOOKING_STATUS_LABELS } from '@/features/dashboard/bookingChanges/types/BillViewModel.utils.ts';
import { bookingStatusTone } from '@/features/dashboard/bookingChanges/components/bookingDetails/bookingHeaderPresentation.ts';

export const bookingStatusTableConfig: EnumTableConfig = Object.fromEntries(
  Object.values(BookingStatus).map((status) => [
    status,
    toneEnumConfig(BOOKING_STATUS_LABELS[status], bookingStatusTone[status]),
  ]),
);
